module.exports = __webpack_public_path__ + "static/media/idea.559714d8.svg";